import React, { useEffect } from 'react';

const Toast = ({ message, type = 'success', show, onClose, duration = 3000 }) => {
  useEffect(() => {
    if (show && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [show, duration, onClose]);

  if (!show) return null;

  const icons = {
    success: 'bi-check-circle-fill',
    error: 'bi-x-circle-fill',
    warning: 'bi-exclamation-triangle-fill',
    info: 'bi-info-circle-fill',
  };

  const colors = {
    success: 'var(--success)',
    error: 'var(--error)',
    warning: 'var(--warning)',
    info: 'var(--info)',
  };

  return (
    <div 
      className="position-fixed top-0 end-0 p-3" 
      style={{ zIndex: 9999, marginTop: '20px' }}
    >
      <div 
        className="toast show" 
        role="alert"
        style={{ 
          minWidth: '300px',
          boxShadow: 'var(--shadow-lg)',
          border: 'none',
          borderLeft: `4px solid ${colors[type]}`
        }}
      >
        <div className="toast-body d-flex align-items-center">
          <i 
            className={`${icons[type]} fs-4 me-3`}
            style={{ color: colors[type] }}
          ></i>
          <span className="flex-grow-1">{message}</span>
          <button 
            type="button" 
            className="btn-close ms-2"
            onClick={onClose}
          ></button>
        </div>
      </div>
    </div>
  );
};

export default Toast;